module.exports = __webpack_public_path__ + "img/logo-scatbook-black-white.bd8e99a0.svg";